import "./publications-page.css"

import { useState } from 'react';
import { NewTabLink } from '../utils';

export default function PublicationCard( {publication} ) {
    const [showLinks, setShowLinks] = useState(false);

    return (
        <div className="publication-card">
            <button
                className="abstract-expansion-button"
                onClick={() => setShowLinks(!showLinks)}
                aria-expanded={showLinks}
                aria-label={`${showLinks ? 'Hide' : 'Show'} links for ${publication.title}`}
            >
                {showLinks ? <>&and;<br/>&and;<br/>&and;</> : <>&or;<br/>&or;<br/>&or;</>}
            </button>
            <div className="publication-text-listing">
                <h3> {publication.title} </h3>
                <p><i>{publication.publication_venue}</i></p>
                <p>{publication.authors.join(', ')}</p>
                {showLinks && (publication.code || publication.site) && (
                    <div className="publication-links">
                        {publication.shortened_abstract && (
                            <p><strong style={{ fontWeight: '600' }}>Tldr: </strong>{publication.shortened_abstract}</p>
                        )}
                        {publication.site && (
                            <p><strong style={{ fontWeight: '600' }}>Site</strong>: <NewTabLink href={publication.site} linkedText={publication.site}/></p>
                        )}
                        {publication.code && (
                            <p><strong style={{ fontWeight: '600' }}>Code: </strong><NewTabLink href={publication.code} linkedText={publication.code}/></p>
                        )}
                    </div>
                )}
            </div>
            <a
                className="shooting-star-button"
                href={publication.pdf}
                target="_blank"
                rel="noreferrer"
                aria-label={`Open ${publication.title} on arXiv`}
            >
                <span className="shooting-star-tail" aria-hidden="true">ᯓ</span>
                <span className="shooting-star-glyph" aria-hidden="true">✩</span>
            </a>
        </div>
    );
};
